/**
 * Storefront — small shared enhancements (Theme Blueprint)
 * ---------------------------------------------------------------------------
 * Auto-submitting selects (sorting/filtering). Kept tiny and dependency-free.
 */
(function () {
  "use strict";
  document.addEventListener("change", function (e) {
    var el = e.target;
    if (el && el.matches && el.matches("[data-auto-submit]")) {
      var form = el.closest("form");
      if (form) form.submit();
    }
  });
})();
